import { Card, Stack } from "react-bootstrap";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { mapItemType, mapItemTypeColor } from "../HelperFunctions";
import ErrorResponse from "../ErrorResponse";
import LoadingIndicator from "../LoadingIndicator";
import RATooltip from "../RATooltip";
import { doughnutOptions, htmlLegendPlugin } from "../chartOptions";

ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function ContentBalanceCard({ data, loading, error }) {
    const chartData = useMemo(() => {
        if (data) {
            return {
                labels: data?.balance.map(x => mapItemType(x.item_type)),
                datasets: [
                    {
                        label: "Time Frame",
                        type: "doughnut",
                        backgroundColor: data?.balance.map(x => mapItemTypeColor(x.item_type)),
                        data: data?.balance.map(x => x.time_frame),
                        datalabels: {
                            anchor: "end",
                        },
                    },
                    {
                        label: "Average",
                        type: "doughnut",
                        backgroundColor: data?.balance.map(x => mapItemTypeColor(x.item_type)),
                        data: data?.balance.map(x => x.average),
                        datalabels: {
                            anchor: "start",
                        },
                    },
                ],
            };
        }
    }, [data]);

    return (
        <Card>
            <Card.Header className="d-flex align-items-center px-2">
                <span className="offset-1 flex-grow-1">Content Balance</span>
                <div className="col-1 d-flex justify-content-end">
                    <RATooltip size={20}>
                        <Stack gap={2}>
                            <span>Shows percentage of Music, Talk, and any other items types shared in Clocks.</span>
                        </Stack>
                    </RATooltip>
                </div>
            </Card.Header>
            <Card.Body className="py-0 card-health-chart d-flex">
                {loading ? (
                    <LoadingIndicator width={85} />
                ) : error ? (
                    <ErrorResponse errorCode={error} />
                ) : (
                    <>
                        <Stack id="legend-container-content-balance" className="py-3"></Stack>
                        <Doughnut data={chartData} options={doughnutOptions("legend-container-content-balance")} plugins={[htmlLegendPlugin]} />
                    </>
                )}
            </Card.Body>
        </Card>
    );
}
